module.exports = __webpack_public_path__ + "img/ic_upload.2ed76bc2.svg";